export class PublicIdService {
  // access id retrieve
  withAccessid(obj, accessid) {
    if (accessid) obj.accessid = accessid;
    return obj;
  }
}
